import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faUser, 
  faChartBar, 
  faMap,
  faClock, 
  faRightFromBracket
} from '@fortawesome/free-solid-svg-icons';
import api from '../../lib/api';
import { logout } from '../../store/slices/authSlice';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    dispatch(logout());
    await api.auth.logout();
    navigate('/login');
  };

  const navigationItems = [
    { name: 'Feed', href: '/feed', icon: faHome },
    { name: 'Profile', href: '/profile', icon: faUser },
    { name: 'Analytics', href: '/analytics', icon: faChartBar },
    { name: 'Explore', href: '/explore', icon: faMap },
    { name: 'History', href: '/history', icon: faClock },
  ];

  const isActiveLink = (href) => location.pathname === href;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-subtle-border">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center h-20">
          <Link to="/feed" className="flex items-center">
            <div className="text-xl font-heading font-semibold text-charcoal tracking-tight hover:opacity-70 transition-opacity duration-200">
              ZoneRuns
            </div>
          </Link>

          <div className="flex items-center space-x-2 flex-1 justify-center">
            {navigationItems.map((item) => {
              const isActive = isActiveLink(item.href);
              
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`px-4 py-2 rounded-card transition-all duration-200 ease-in-out ${
                    isActive 
                      ? 'text-white bg-cool-steel' 
                      : 'text-charcoal hover:text-cool-steel hover:bg-frost-blue'
                  }`}
                >
                  <div className="flex items-center space-x-2.5">
                    <FontAwesomeIcon icon={item.icon} className="w-4 h-4" />
                    <span className="font-medium text-sm">{item.name}</span>
                  </div>
                </Link>
              );
            })}
          </div>

          <button
            onClick={handleLogout}
            className="px-4 py-2 rounded-card text-charcoal hover:text-red-500 hover:bg-red-50 hover:scale-[1.05] active:scale-[0.95] transition-all duration-200 ease-in-out"
          >
            <div className="flex items-center space-x-2.5">
              <FontAwesomeIcon icon={faRightFromBracket} className="w-4 h-4" />
              <span className="font-medium text-sm">Logout</span>
            </div>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
